import type { ButtonProps } from '@mui/material';

import { forwardRef } from 'react';

import { alpha, styled, Button } from '@mui/material';

const StyledButton = styled(Button)(({ theme }) => ({
  '&:hover': {
    borderColor: alpha(theme.palette.grey[700], 0.08),
    boxShadow: 'unset',
  },
  ':first-of-type': {
    '&:hover': {
      borderRightColor: alpha(theme.palette.grey[700], 0.08),
    },
  },
}));

const ForwardedStyledButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
  <StyledButton ref={ref} {...props} />
));

export default ForwardedStyledButton;
